var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7290",
    "data-name": "Group 7290",
    transform: "translate(-18 -85)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 45,
    height: 45,
    rx: 10,
    transform: "translate(18 85)",
    fill: "#4b58ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22961",
    "data-name": "Path 22961",
    d: "M6.75,2.5A4.25,4.25,0,0,1,11,6.75V11H6.75a4.25,4.25,0,1,1,0-8.5ZM9,9V6.75A2.25,2.25,0,1,0,6.75,9ZM6.75,13H11v4.25A4.25,4.25,0,1,1,6.75,13Zm0,2A2.25,2.25,0,1,0,9,17.25V15ZM17.25,2.5a4.25,4.25,0,1,1,0,8.5H13V6.75A4.25,4.25,0,0,1,17.25,2.5Zm0,6.5A2.25,2.25,0,1,0,15,6.75V9ZM13,13h4.25A4.25,4.25,0,1,1,13,17.25Zm2,2v2.25A2.25,2.25,0,1,0,17.25,15Z",
    transform: "translate(29 96)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconBlue);
export default __webpack_public_path__ + "static/media/menu-icon-blue.efba98c6b2600be0785862f005bc0a3e.svg";
export { ForwardRef as ReactComponent };